<template>
  <div class="box">
    <div class="top">
        <div class="title">
        <img src="./images/huati.svg">
        话题合集
      </div>
      <div class="swiper">
        <ROTATION v-if="getCenterAuth.rotation" />
        <!-- <van-swipe indicator-color="'#39a9ed'" class="my-swipe" :autoplay="3000" >
          <van-swipe-item>1</van-swipe-item>
          <van-swipe-item>2</van-swipe-item>
          <van-swipe-item>3</van-swipe-item>
          <van-swipe-item>4</van-swipe-item>
        </van-swipe> -->
      </div>
      <div class="top_dynamic">
        <div class="top_dynamicList one_list">
          <div @click="goDynamic(item)" v-for="(item,index) in TopicList.slice(0,3)" :key="index"># {{item.name || ''}}</div>
        </div>
        <div class="top_dynamicList two_list">
          <div @click="goDynamic(item)" v-for="(item,index) in TopicList.slice(3,6)" :key="index"># {{item.name || ''}}</div>
        </div>
      </div>
    </div>
    <div style="width:100%;height:5px;background-color: #EEE;"></div>
    <div class="bottom">
      <div class="title">
        <div class="left">
          <div class="icon"></div>
          <div class="name">全部话题</div>
        </div>
        <div class="all" @click="goDynamicList">查看全部话题></div>
      </div>
      <div class="dynamic_list">
        <DYNAMICCRADVUE @click.native="goDynamic(item)" style="margin-top:24.5px;" v-for="(item,index) in AllTopicList.slice(0,4)" :index="index" v-bind="item" :key='item.id' />
      </div>
    </div>
  </div>
</template>

<script>
import DYNAMICCRADVUE from './components/dynamicCrad.vue'
import ROTATION from '../../../components/Rotation.vue'
import { get as getUser } from '../../../utils/token'
import { getTopicollections } from '../../../api/api'
export default {
  components: {
    DYNAMICCRADVUE,
    ROTATION
  },
  data () {
    return {
      user: getUser('user'),
      TopicList: [],
      AllTopicList: []
    }
  },
  async mounted () {
    if (this.HotTopicList.length === 0) {
      await this.$store.dispatch('TopicList/getTopicList', this.user.id)
    }
    this.TopicList = this.HotTopicList.flat(Infinity)
    this.getAllTopic()
  },
  methods: {
    async getAllTopic () {
      try {
        const result = await getTopicollections()
        if (result.code === 200) {
          this.AllTopicList = result.detail
        }
      } catch (error) {
        /* eslint-disable */
        console.log(error)
      }
    },
    goDynamicList () {
      this.$router.push('/exerland/dynamicList')
    },
    goDynamic (tag) {
      this.$router.push({
        name: 'FilterFind',
        params: {
          id: tag.id,
          title: tag.name || tag.title
        }
      })
    }
  },
  computed: {
    getCenterAuth () {
      return this.$store.getters['homeAuth/getAuth'] || {}
    },
    HotTopicList () {
      return this.$store.getters['TopicList/getAuth']
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  height: 100%;
  background: #fff;
  .bottom {
    padding: 20.5px 20.5px 0 18px;
    .title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        align-items: center;
      }
      .all {
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
      }
      .name {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 600;
        font-style: italic;
        color: #000000;
        margin-left: 9px;
      }
      .icon {
        width: 2.5px;
        height: 12.5px;
        background: #353535;
        border-radius: 1px;
      }
    }
  }
  .top {
    padding-bottom: 34.5px;
    .top_dynamic {
      display: flex;
      width: 335px;
      margin: 16.5px auto 0;
      .one_list {
        width: 50%;
        border-right: 1px solid #dcdcdc;
      }
      .two_list {
        width: 50%;
        padding-left: 15px;
      }
      .top_dynamicList {
        width: 50%;
        & div:not(:last-child){
          margin-bottom: 5px;
        }
        div {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
    .swiper {
      width: 335px;
      margin: 20px auto;
      border-radius: 10px;
      .my-swipe {
        border-radius: 10px;
        .van-swipe-item {
          height: 113px;
          color: #fff;
          font-size: 20px;
          // line-height: 150px;
          text-align: center;
          background-color: #39a9ed;
        }
      }
    }
    .title {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 600;
      font-style: italic;
      margin: 20px 0 0 18.5px;
      img {
        width: 19.5px;
      }
    }
  }
}
</style>
